export default __webpack_public_path__ + "static/media/fastlane.8d097fef.png";